/**
 * Ticketify brand logo — single source of truth.
 *
 * Two PNG variants live in `/public/brand/`:
 *   - ticketify-logo.png      (black wordmark, for light backgrounds)
 *   - ticketify-logo-dark.png (white wordmark, for dark backgrounds)
 *
 * Both are PNG with transparent backgrounds (cropped to bbox). The icon
 * (blue→green gradient) is identical in both files.
 *
 * Dark/light variant is swapped via CSS using the global `[data-theme]`
 * attribute set on <html> by ThemeToggle.
 */
export default function BrandLogo({ className = "", height = 48 }) {
    const wrapperStyle = { height, width: "auto" };
    return (
        <span
            className={`tk-brand-logo inline-flex items-center shrink-0 select-none ${className}`}
            style={wrapperStyle}
            aria-label="Ticketify"
        >
            <img
                src="/brand/ticketify-logo.png"
                alt="Ticketify"
                className="tk-brand-light h-full w-auto"
                draggable={false}
            />
            <img
                src="/brand/ticketify-logo-dark.png"
                alt=""
                aria-hidden
                className="tk-brand-dark h-full w-auto"
                draggable={false}
            />
        </span>
    );
}
